import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { _onClearDentalRecordData } from "../../../redux/actions/dentalRecordAction";
import AssessmentBreadcrumb from "../assessment-breadcrumbs/AssessmentBreadrumb";

const AssessmentAppHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  // Remove trailing slashes for accurate comparison
  const currentPath = location.pathname.replace(/\/$/, "");

  // Map of URL paths to page titles
  const pageTitleMap = {
    "/age-assessment/cases/age-group/sub-adult/primary":
      "Primary Teeth Staging (Children)",
    "/age-assessment/cases/age-group/adults/radiographic-tooth-analysis":
      "Radiographic Tooth Analysis (Adult)",
    "/age-assessment/cases/age-group/sub-adult/permanent":
      "Permanent Teeth Staging (Juvenile)",
    "/age-assessment/cases/age-group/adults/intact-tooth-analysis":
      "Intact Tooth Analysis (Adult)",
    "/age-assessment/cases/age-group/sub-adult/wisdome":
      "Wisdom Teeth Staging (Adolescent)",
    "/age-assessment/cases/age-group/adults/sectioned-tooth-analysis":
      "Sectioned Tooth Analysis (Adult)",
    "/age-assessment/cases": "Case Records", // Add other pages as needed
    "/age-assessment/cases/details": "Case Details", // Add other pages as needed
    "/age-assessment/tutorial": "Tutorials", // Add other pages as needed
    "/age-assessment/faqs": "FAQ's", // Add other pages as needed
    "/age-assessment/settings": "Settings", // Add other pages as needed
    "/age-assessment/support": "Support", // Add other pages as needed
    "/age-assessment/cases/age-group": "Estimation Methods", // Add other pages as needed
    "/age-assessment/dashboard": "Dashboard", // Add other pages as needed
    "/age-assessment/cases/new-case": "Case Registration", // Add other pages as needed
    "/age-assessment/cases/new-case/dental-examination": "Dental Charting", // Add other pages as needed
  };

  const pageDescriptionMap = {
    "/age-assessment/cases/new-case":
      "Enter subject information and referral details to initiate a new case for age estimation.",
    "/age-assessment/cases/new-case/dental-examination":
      "Conduct the dental exam, record tooth-specific findings, and upload relevant radiographs.",
    "/age-assessment/cases":
      "View all registered cases with filters by status to continue analysis or perform audits.",
    "/age-assessment/cases/details":
      "Review subject information, and assessment purpose, to start the case analysis.",
    "/age-assessment/cases/age-group":
      "Select the age group and the corresponding method to start the age assessment.",
  };

  let description = pageDescriptionMap[currentPath];

  // Default title from the map
  let title = pageTitleMap[currentPath];

  // If the path is /projects/details/:id, set the title to "Project Details"
  if (currentPath.startsWith("/age-assessment/cases/details")) {
    // Check if the path matches the project details format (details/:id)
    const pathParts = currentPath.split("/");
    if (pathParts.length === 5 && pathParts[4]) {
      title = "Project Details";
    }
  }
  // If the path is /dental-identification/projects/case/results/i:d, set the title to "Project Details"
  if (currentPath.startsWith("/dental-identification/projects/case/results")) {
    // Check if the path matches the project details format (details/:id)
    const pathParts = currentPath.split("/");
    if (pathParts.length === 6 && pathParts[4] === "results" && pathParts[5]) {
      title = "Results";
    }
  }
  // If the path is /dental-identification/projects/case/results/i:d, set the title to "Project Details"
  if (
    currentPath.startsWith("/dental-identification/projects/case/all-records")
  ) {
    // Check if the path matches the project details format (details/:id)
    const pathParts = currentPath.split("/");
    if (
      pathParts.length === 6 &&
      pathParts[4] === "all-records" &&
      pathParts[5]
    ) {
      title = "All Records";
    }
  }

  // If title not found, use the default title
  title = title || "Default Title";

  return (
    <div className="app_header">
      <div className="flex flex-col">
        <div className="page_title font-semibold text-lg mt-2">{title}</div>
        <div>
          <p
            style={{ color: "rgba(57, 59, 74, 0.7)", fontSize: "13px" }}
            className="font-normal"
          >
            {description || ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AssessmentAppHeader;
